import React, { createContext, useState, useContext, useEffect } from "react";

const GenericFormContext = createContext({});

export const GenericFormProvider = ({
  children,
  formDataName,
  emptyFormData,
}) => {
  const [formData, updateFormData] = useState(() => {
    try {
      const storedData = sessionStorage.getItem(formDataName);
      return storedData ? JSON.parse(storedData) : emptyFormData;
    } catch (error) {
      console.error("Error parsing stored data:", error);
      return {};
    }
  });

  useEffect(() => {
    sessionStorage.setItem(formDataName, JSON.stringify(formData));
    return () => {
      sessionStorage.removeItem(formDataName);
    };
  }, [formData, formDataName]);

  const clearFormData = () => {
    sessionStorage.setItem(formDataName, {});
  };

  const setFormData = (newData) => {
    updateFormData((prevData) => ({ ...prevData, ...newData }));
  };

  return (
    <GenericFormContext.Provider
      value={{
        formData,
        clearFormData,
        setFormData,
      }}
    >
      {children}
    </GenericFormContext.Provider>
  );
};

export const useGenericFormContext = () => useContext(GenericFormContext);
